import { fetcher } from "helpers/fetcher";

import { TGetDetailOrganizationReq, TGetDetailOrganizationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getDetailOrganization = async (
  params?: TGetDetailOrganizationReq
) => {
  return await fetcher<TGetDetailOrganizationRes, TGetDetailOrganizationReq>(
    ENDPOINT.CORPORATION.GET_DETAIL_ORGANIZATION,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_DETAIL_ORGANIZATION.version,
        [API_HEADER.CORP_ID]: params?.idCorp,
        [API_HEADER.BLOCK_404]: true,
      },
    }
  );
};

export const queryGetDetailOrganization = async (
  params?: TGetDetailOrganizationReq
) => {
  return (await getDetailOrganization(params)).data;
};

queryGetDetailOrganization._key = (params?: TGetDetailOrganizationReq) => [
  ENDPOINT.CORPORATION.GET_DETAIL_ORGANIZATION.url,
  params,
];
